module.exports = __webpack_public_path__ + "img/icon_2_48.f70efc12.png";